import React, { useState, useEffect } from "react";
import CardIcon from "../../../assets/svg/cardlogo.svg";
import { FetchSavedCards, DeleteSavedToken } from "../../../Services/PaymentService";
import DeleteConfirmModal from "../AccountSetting/DeleteConfirmModal";

const UserCards = () => {
  const [savedCards, setSavedCards] = useState([]);
  const [savedUpi, setSavedUpi] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [methodToDelete, setMethodToDelete] = useState(null);

  const currentCustomerId = localStorage.getItem("razorpayCustomerId");

  // Fetch saved tokens
  useEffect(() => {
    const fetchTokens = async () => {
      try {
        if (!currentCustomerId) return;

        const response = await FetchSavedCards(currentCustomerId);

        if (response.status && response.data?.data?.length > 0) {
          const responseData = response.data.data;

          setSavedCards(
            responseData
              .filter(t => t.method === "card")
              .map(t => ({
                token: t.tokenId,
                last4: t.card.last4,
                network: t.card.network,
                name: t.card.name || `${t.card.network} Card`
              }))
          );

          setSavedUpi(
            responseData
              .filter(t => t.method === "upi")
              .map(t => ({
                token: t.tokenId,
                vpa: t.upi.vpa,
                name: t.upi.vpa
              }))
          );
        }
      } catch (error) {
        console.error("Failed to fetch saved payment methods", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTokens();
  }, [currentCustomerId]);

  // Open delete modal
  const handleDeletePaymentMethod = (method) => {
    setMethodToDelete(method);
    setShowDeleteModal(true);
  };

  // Confirm delete
  const confirmDeletePaymentMethod = async () => {
    if (!methodToDelete || !currentCustomerId) return;

    try {
      const response = await DeleteSavedToken(
        currentCustomerId,
        methodToDelete.tokenId
      );

      if (response.data?.status) {
        if (methodToDelete.type === "card") {
          setSavedCards(prev =>
            prev.filter(c => c.token !== methodToDelete.tokenId)
          );
        } else {
          setSavedUpi(prev =>
            prev.filter(u => u.token !== methodToDelete.tokenId)
          );
        }
      }
    } catch (error) {
      console.error("Delete token failed", error);
    } finally {
      setShowDeleteModal(false);
      setMethodToDelete(null);
    }
  };

  if (loading) {
    return <div className="main-content">Loading saved payment methods...</div>;
  }

  return (
    <>
      <div className="main-content">
        <div className="user-card-grid">
          {savedCards.length === 0 && savedUpi.length === 0 ? (
            <p>No saved payment methods found.</p>
          ) : (
            <>
              {/* Cards */}
              {savedCards.map((card, index) => (
                <div
                  key={card.token}
                  className="user-card d-flex align-items-start justify-content-between gap-2"
                >
                  <div className="d-flex align-items-start">
                    <div className="form-check custom-radio mr_10">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="selectedCard"
                        id={`card-${index}`}
                      />
                    </div>
                    <div>
                      <h5 className="fs_16 fw_400 text-black mb_12">
                        {card.name}
                      </h5>
                      <p className="fs_14 fw_400 mb-0">**** {card.last4}</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <h6
                      className="fs_16 fw_400 mr_12 text-decoration-underline mb_0"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleDeletePaymentMethod({
                          tokenId: card.token,
                          type: "card",
                          name: card.name
                        })
                      }
                    >
                      Remove
                    </h6>
                    <img src={CardIcon} alt="" />
                  </div>
                </div>
              ))}

              {/* UPI */}
              {savedUpi.map((upi, index) => (
                <div
                  key={upi.token}
                  className="user-card d-flex align-items-start justify-content-between gap-2"
                >
                  <div className="d-flex align-items-start">
                    <div className="form-check custom-radio mr_10">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="selectedUpi"
                        id={`upi-${index}`}
                      />
                    </div>
                    <div>
                      <h5 className="fs_16 fw_400 text-black mb_12">
                        Saved UPI
                      </h5>
                      <p className="fs_14 fw_400 mb-0">{upi.vpa}</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <h6
                      className="fs_16 fw_400 mr_12 text-decoration-underline mb_0"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleDeletePaymentMethod({
                          tokenId: upi.token,
                          type: "upi",
                          name: upi.vpa
                        })
                      }
                    >
                      Remove
                    </h6>
                    <img src={CardIcon} alt="" />
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <DeleteConfirmModal
        show={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setMethodToDelete(null);
        }}
        onConfirm={confirmDeletePaymentMethod}
        itemName={methodToDelete?.name || "payment method"}
      />
    </>
  );
};

export default UserCards;